// removed by extract-text-webpack-plugin
module.exports = {"Section":"src-components-Section----Section-module---Section---2F_FA","Header":"src-components-Section----Section-module---Header---3YKNJ","canCollapse":"src-components-Section----Section-module---canCollapse---2H7tc","Arrow":"src-components-Section----Section-module---Arrow---19jpk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Section/Section.module.css
// module id = 357
// module chunks = 35783957827783